module.exports = __webpack_public_path__ + "static/media/logo.de1cae53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 52
// module chunks = 0